import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getEnrollStudents, 
    addEnrollStudents as postEnrollStudents, 
    updateEnrollStudents as putEnrollStudents, 
    deleteEnrollStudents as removeEnrollStudents,
    updateEnrollStudentsCoursePayment as putEnrollStudentsCoursePayment
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Fetch Table Column Names
export const fetchEnrollStudentsTableColumnNames = createAsyncThunk("enrollStudents/fetchTableColumnNames", async (enrollStudents, thunkAPI) => {
    try {
      const response = await getHeaders(enrollStudents); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Enroll Students
export const fetchAllEnrollStudents = createAsyncThunk("enrollStudents/fetchAll", async (thunkAPI) => {
    try {
      const response = await getEnrollStudents(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Enroll Students
export const createEnrollStudents = createAsyncThunk("enrollStudents/add", async (enrollStudents, thunkAPI) => {  
    try {
        const response = await postEnrollStudents(enrollStudents);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Enroll Students
export const updateEnrollStudents = createAsyncThunk("enrollStudents/update", async (enrollStudents, thunkAPI) => {
    try {
        const response = await putEnrollStudents(enrollStudents);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Enroll Students
export const deleteEnrollStudents = createAsyncThunk("enrollStudents/delete", async (enrollStudents, thunkAPI) => {
    try {
        const response = await removeEnrollStudents(enrollStudents);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Enroll Students Course Payment
export const updateEnrollStudentsCoursePayment = createAsyncThunk("enrollStudents/coursepayment", async (enrollStudents, thunkAPI) => {
    try {
        const response = await putEnrollStudentsCoursePayment(enrollStudents);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});